import { render, staticRenderFns } from "./labour.vue?vue&type=template&id=b2422d1a&scoped=true&"
import script from "./labour.vue?vue&type=script&lang=js&"
export * from "./labour.vue?vue&type=script&lang=js&"
import style0 from "./labour.vue?vue&type=style&index=0&id=b2422d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2422d1a",
  null
  
)

export default component.exports